import React from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import HomeSlider from "../Components/HomeSlider";
import { clientsData, prductData } from "../Data";
import Aos from "aos";

const Home = ({ openDemo }) => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-800">
      <HomeSlider openDemo={openDemo} />

      <section id="about" className="relative py-12 md:py-20 bg-white border-b border-slate-200">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: "radial-gradient(#CBD5E1 1px, transparent 1px)",
            backgroundSize: "24px 24px",
          }}
        />

        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10">

          {/* mobile layout */}
          <div className="lg:hidden">
            <div className="mb-2">
              <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
                Founder's Journey
              </span>
            </div>

            {/* heading */}
            <div className="flex items-start gap-3 mb-4">
              <h2 className="flex-1 text-3xl font-teko uppercase text-slate-900 tracking-wide leading-tight">
                Transforming Industry through{" "}
                <span className="text-blue-600">Practical Innovation</span>
              </h2>
            
              <div className="w-24 flex-shrink-0 relative rounded-2xl mt-10 ml-auto overflow-hidden border-2 border-white shadow-xl bg-slate-50">
                <img
                  className="w-full h-auto object-cover"
                  src={require("../assets/founder.png")}
                  alt="Pravin Kashid"
                />
                <div className="absolute bottom-0 inset-x-0 bg-blue-900/80 py-1 px-1 text-center">
                  <p className="text-[7px] font-bold uppercase tracking-wide text-blue-200">
                    Founder
                  </p>
                </div>
              </div>
            </div>

            {/* description */}
            <p className="text-sm text-slate-600 mb-5 leading-relaxed">
              BFI was founded in 2018 with a vision to transform traditional laboratory and
              industrial operations through smart, practical, and scalable software solutions.
              Our founder's journey from engineering at{" "}
              <strong>L&amp;T</strong> to digital innovation has shaped our customer-centric approach.
            </p>

            <div className="grid grid-cols-2 gap-2.5 mb-5">
              {[
                "Quality Services",
                "Innovative Digitalization",
                "Competitive Cost",
                "24/7 Technical Support",
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <FaCheck className="text-blue-600 text-[10px] flex-shrink-0" />
                  <span className="text-slate-700 font-bold text-[10px] uppercase tracking-wide">
                    {item}
                  </span>
                </div>
              ))}
            </div>


            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center justify-center px-6 py-2.5 bg-blue-700 hover:bg-blue-800 text-white rounded-lg font-bold transition-all uppercase tracking-widest text-[10px] shadow-lg"
              >
                Know More
              </Link>
              <div className="flex items-center gap-4 pl-3 border-l border-slate-200">
                {[
                  { val: "200+", label: "Clients" },
                  { val: "5+", label: "Products" },
                  { val: "8+", label: "Years" },
                ].map((s, i) => (
                  <div key={i} className="text-center">
                    <p className="text-xl font-teko text-blue-700 leading-none">{s.val}</p>
                    <p className="text-[9px] font-bold text-slate-400 uppercase">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* desktop layout */}
          <div className="hidden lg:flex gap-12 items-center">
            {/* founder img */}
            <div className="lg:w-1/3 flex justify-center" data-aos="fade-right">
              <div className="relative group max-w-[320px]">
                <div className="relative overflow-hidden rounded-[2rem] shadow-xl border-4 border-white bg-slate-50 transition-all duration-500 hover:shadow-2xl">
                  <img
                    className="w-full h-auto object-cover transition-all duration-700"
                    src={require("../assets/founder.png")}
                    alt="Pravin Kashid"
                  />
                  <div className="absolute inset-0 bg-blue-900/40 opacity-0 hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                    <div className="text-white">
                      <p className="text-xl font-teko uppercase tracking-wider">Pravin Kashid</p>
                      <p className="text-[10px] font-bold uppercase tracking-widest text-blue-200">
                        Founder
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* content */}
            <div className="lg:w-2/3" data-aos="fade-left">
              <div className="mb-4">
                <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
                  Founder's Journey
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide mb-6 leading-tight">
                Transforming Industry through{" "}
                <span className="text-blue-600">Practical Innovation</span>
              </h2>
              <p className="text-sm md:text-base text-slate-600 mb-8 leading-relaxed text-justify">
                BFI was founded in 2018 with a vision to transform traditional laboratory and
                industrial operations through smart, practical, and scalable software solutions.
                <br />
                <br />
                Our founder's journey from engineering at <strong>L&amp;T</strong> to digital
                innovation has shaped our customer-centric approach. We don't just build software;
                we solve real-world industry problems through digital expertise.
              </p>

              <div className="grid grid-cols-2 gap-4 mb-10">
                {[
                  "Quality Services",
                  "Innovative Digitalization",
                  "Competitive Cost",
                  "24/7 Technical Support",
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <FaCheck className="text-blue-600 text-xs" />
                    <span className="text-slate-700 font-bold text-[10px] uppercase tracking-wide">
                      {item}
                    </span>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-4">
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center px-8 py-3 bg-blue-700 hover:bg-blue-800 text-white rounded-lg font-bold transition-all uppercase tracking-widest text-[10px] shadow-lg hover:shadow-blue-200"
                >
                  Know More
                </Link>
                <div className="flex items-center gap-3 px-4 border-l border-slate-200">
                  <div className="text-center">
                    <p className="text-2xl font-teko text-blue-700 leading-none">200+</p>
                    <p className="text-[10px] font-bold text-slate-400 uppercase">Clients</p>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl font-teko text-blue-700 leading-none">5+</p>
                    <p className="text-[10px] font-bold text-slate-400 uppercase">Products</p>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl font-teko text-blue-700 leading-none">8+</p>
                    <p className="text-[10px] font-bold text-slate-400 uppercase">
                      Years Experience
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="product" className="relative py-12 md:py-20 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10">
          {/* header */}
          <div className="text-center max-w-3xl mx-auto mb-8" data-aos="fade-up">
            <div className="mb-2">
              <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
                Our Products
              </span>
            </div>
            {/* title */}
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide mb-3">
              Exclusively Advanced Software
            </h2>
            <p className="text-slate-600 text-sm">
              Explore our suite of proprietary software solutions designed to streamline your
              business operations and accelerate digital transformation.
            </p>
          </div>

          <div
            className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {prductData?.map((post, index) => (
              <Link
                key={index}
                to={`/product/${post.id}`}
                className={`group relative overflow-hidden bg-white border-2 border-slate-200 rounded-xl shadow-md aspect-square hover:border-blue-400 transition-all duration-300 block ${
                  index >= 4 ? "hidden lg:block" : ""
                }`}
                data-aos="fade-up"
                data-aos-delay={index * 40}
              >
                <img
                  src={post.image}
                  alt={post.title}
                  className="absolute inset-0 h-full w-full object-contain object-center p-3 md:p-4"
                />

                <div
                  className="
                    absolute bottom-0 left-0 right-0
                    mx-2 mb-2
                    bg-white/95 backdrop-blur-md
                    border border-slate-200
                    shadow-xl
                    rounded-lg
                    transition-transform duration-500 ease-in-out
                    translate-y-[calc(100%-44px)]
                    group-hover:translate-y-0
                  "
                >
                  <div className="p-3 md:p-5">
                    <h3 className="text-[11px] md:text-base font-semibold leading-snug text-slate-800 line-clamp-2">
                      {post.title}
                    </h3>
                    <p className="mt-1 text-[10px] md:text-sm leading-5 text-slate-600 line-clamp-2 hidden md:block">
                      {post.description}
                    </p>
                    <span className="mt-2 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-blue-600">
                      View Details
                      <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* view all */}
          <div className="text-center mt-8 lg:hidden">
            <Link
              to="/product"
              className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-lg font-bold uppercase tracking-widest text-[10px] transition-all"
            >
              View All Products
              <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      <section className="relative py-12 md:py-20 bg-blue-900 overflow-hidden border-b border-blue-200">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-400 via-blue-800 to-slate-900" />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)",
            backgroundSize: "30px 30px",
          }}
        />

        <div
          className="max-w-7xl mx-auto px-5 lg:px-8 text-center relative z-10 mb-8 md:mb-12"
          data-aos="fade-up"
        >
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-white tracking-wide">
            Technologies We Work With
          </h2>
        </div>

        {/* marquee */}
        <div className="relative flex overflow-x-hidden group py-4">
          <div className="absolute top-0 left-0 w-16 md:w-24 h-full bg-gradient-to-r from-blue-900 to-transparent z-10 pointer-events-none" />
          <div className="absolute top-0 right-0 w-16 md:w-24 h-full bg-gradient-to-l from-blue-900 to-transparent z-10 pointer-events-none" />

          <div className="flex animate-marquee group-hover:[animation-play-state:paused] whitespace-nowrap gap-4 md:gap-6 px-4">
            {[
              "React", "Node.js", "Python", "Java", "PHP", "Node.js", "MongoDB", "MySQL",
              "Material UI", "IndexedDB", "Python", "tailwind", "Create React App", "JavaScript",
              "React", "Node.js", "Python", "Java", "PHP", "Node.js", "MongoDB", "MySQL",
              "Material UI", "IndexedDB", "Python", "tailwind", "Create React App", "JavaScript"
            ].map((tech, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center w-28 h-24 md:w-40 md:h-32 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer group/card shadow-2xl"
              >
                <div className="text-blue-400 font-black text-3xl md:text-5xl mb-1 font-teko group-hover/card:scale-110 transition-transform">
                  {tech[0]}
                </div>
                <span className="text-white font-bold text-[9px] md:text-xs uppercase tracking-widest">
                  {tech}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-20 bg-white relative">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center mb-8 md:mb-12" data-aos="fade-up">
            <div className="mb-2">
              <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-blue-400 pb-1">
                Our Clients
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-teko uppercase text-slate-900 tracking-wide">
              Our Prestigious Clients
            </h2>
          </div>

          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {clientsData.map((client) => (
              <div
                key={client.id}
                className="group flex flex-col items-center justify-center bg-white p-3 md:p-6 rounded shadow-sm border border-slate-200 hover:shadow-md transition-shadow duration-300"
              >
                <div className="h-12 md:h-16 flex items-center justify-center w-full mb-2 md:mb-3">
                  <img
                    src={client.imageSrc}
                    alt={client.name}
                    className="max-h-full max-w-full object-contain transition-all duration-300"
                  />
                </div>
                <span className="text-[8px] md:text-xs font-bold text-slate-600 uppercase tracking-wider text-center leading-tight">
                  {client.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
